// @flow
import React from 'react';
import Experience from 'app/common/react/components/experiences/Experience/Experience';
import withPlacement from 'app/common/lib/react/experiences/withPlacement';
import ZendeskChat from 'app/common/react/components/growth/smb/ZendeskChat/ZendeskChat';

export function ZendeskChatWrapper() {
  return (
    <Experience
      experienceIds={[PCONST.thrift.Experience.ZENDESK_LIVE_CHAT_FOR_SMB]}
      placementId={PCONST.thrift.Placement.ZENDESK_LIVE_CHAT}
    >
      <ZendeskChat />
    </Experience>
  );
}

export default withPlacement(PCONST.thrift.Placement.ZENDESK_LIVE_CHAT)(ZendeskChatWrapper);
